import axios from "axios";

import {
  gotoLogInPage
} from './error-handler'
let base = '/api'
let projects = `${base}/projects`
let assets = `${base}/assets`
let user = `${base}/user`
let live = `${base}/live/projects`
let baize = `${base}/baize/problems/project`
let homework = `${base}/afterclasstest`
let baizeGoldCoin = `${base}/baize/sync/que/submit`
const handleResponse = (res) => res.data.data

let ASSETS_VERSION = '2312312'
const addRandomQuery = (url) => {
  if (url.indexOf('?') !== -1) {
    return `${url}&random=${ASSETS_VERSION}`
  } else {
    return `${url}?random=${ASSETS_VERSION}`
  }
}

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          gotoLogInPage()
          break;

        default:
        return Promise.reject(error.response)
        break;
      }
    }
  }
)
export default {
  saveBackgroundProject(params) {
    return axios.post(`${projects}/save_pro`, params).then(res => handleResponse(res))
    .catch(err => {
      alert(err.data.message)
    })
  },
  saveAsTeacherWork(params) {
    return axios.post(`${projects}/save_as_pro`, params).then(res => handleResponse(res))
    .catch(err => {
      alert(err.data.message)
    })
  },
  saveProject(params) {
    return axios.post(`${projects}/save`, params).then(res => handleResponse(res))
    .catch(err => {
      alert(err.data.message)
    })
  },
  uploadBase64(params) {
    return axios.post(`${assets}/upload_base64`, params).then(res => handleResponse(res))
  },
  publishProject(params) {
    return axios.post(`${projects}/${params.projectId}/publish`, params).then(res => handleResponse(res))
  },
  getUserInfo() {
    return axios.get(`${user}/info`).then(res => handleResponse(res))
  },
  getProjectById(id) {
    return axios.get(`${projects}/${id}`).then(res => handleResponse(res))
  },
  getMBlockToken(id) {
    return axios.post(`${base}/makeblock/get_access_token`).then(res => handleResponse(res))
  },
  refreshMBlockToken(id) {
    return axios.post(`${base}/makeblock/refresh_access_token`).then(res => handleResponse(res))
  },
  getLiveProject(params) {
    return axios.get(`${live}/detail`, {
      params
    }).then(res => handleResponse(res))
  },
  saveLiveProject(params) {
    return axios.post(`${live}/save`, params).then(res => handleResponse(res))
  },
  checkLiveProject(params) {
    return axios.get(`${live}/check_answer`, params).then(res => handleResponse(res))
  },
  submitLiveProject(params) {
    return axios.post(`${live}/v3/submit`, params).then(res => handleResponse(res))
  },
  getHomeworkInfo(params) {
    return axios.get(`${homework}/getobjecttestinfo`, {
      params
    }).then(res => handleResponse(res))
  },
  checkCode(params) {
    return axios.post(`${live}/v3/check_answer`, params).then(res => res)
  },
  getBackdropLibrary() {
    return axios.get(addRandomQuery('https://rescode.xesimg.com/hufu-code/common/mit/medialibraries/S3/backdropLibrary3.json'))
      .then(res => res.data)
    // return axios.get('https://rescode.xesimg.com/hufu-code/common/mit/medialibraries/backdropLibraryTest.xes')
    //           .then(res => res.data)
  },
  //以下为修改后的角色文件
  getSprites() {
    return axios.get(addRandomQuery('https://rescode.xesimg.com/hufu-code/common/mit/medialibraries/S3/sprites3.json'))
      .then((data) => data.data)
  },
  getCostumes() {
    return axios.get(addRandomQuery('https://rescode.xesimg.com/hufu-code/common/mit/medialibraries/S3/costumeLibrary.json'))
      .then(data => data.data)
  },
  getSounds() {
    return axios.get(addRandomQuery('https://rescode.xesimg.com/hufu-code/common/mit/medialibraries/S3/soundLibrary.json'))
      .then(data => data.data)
  },
  getScratchKeyboard(params) {
    return axios.post(`${projects}/v3/keyboard`, params).then(res => handleResponse(res))
  },
  sendLog(params) {
    return axios.post(`${base}/codelog`, params).then(res => handleResponse(res))
  },
  // live/projects/get_intelligent_prompt
  // live/projects/get_intelligent_prompt
  // 获取C++/Python编程配置 智能提示的知识点和解题思路
  getIntelligentPrompt(id) {
    return axios
      .get(`${base}/live/projects/get_intelligent_prompt?template_project_id=` + id)
      .then(res => res.data.data)
  },
  /**
   * 白泽题库接口
   */
  getBaizeProject (params) {
    return axios.get(`${baize}/problem`, { params }).then(res => handleResponse(res))
  },
  getBaizeProjectNew (params) {
    return axios.get(`${base}/tiku/problem`, {params}).then(res => handleResponse(res));
  },  
  getBaizeAnswerProject (params) {
    return axios.get(`${baize}/answer/user_answer`, { params }).then(res => handleResponse(res))
  },
  getBaizeAnswerProjectNew (params) {
    return axios.get(`${base}/tiku/problem/commit/detail`, {params}).then(res => handleResponse(res));
  },
  checkBaizeProject(params){
    return axios.post(`${baize}/answer/correct`, params)
  },
  checkBaizeProjectNew (params){
    return axios.post(`${base}/tiku/problem/correct`, params);
  },
  submitBaizeProject (params) {
    return axios.post(`${baize}/answer/submit`, params).then(res => handleResponse(res))
  },
  submitBaizeProjectNew (params) {
    return axios.post(`${base}/tiku/practice/commit_problem`, params).then(res => handleResponse(res));
  },
  getBaizeGoldCoin (params) {
    return axios.post(baizeGoldCoin, params).then(res => handleResponse(res))
  },
  // 文件上传
  getUploadParams(ext){
    return axios
      .get(`${base}/python/get_upload_service_params?ext=` + ext)
      .then(res => res.data.data)
  },
  // 上传并获取返回地址
  getUploadFile(url, file, headers){
    return axios
      .put(url,
        file, {
          headers: headers
        })
      .then(res => res.data.data)
  },
}